import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly _isSidebarOpen = signal(true);

  public readonly isSidebarOpen = this._isSidebarOpen.asReadonly();

  public setSidebarState(): void {
    this._isSidebarOpen.update((value) => !value);
  }
}
